import { render, staticRenderFns } from "./StepNavi.vue?vue&type=template&id=2f56437c&scoped=true&"
import script from "./StepNavi.vue?vue&type=script&lang=ts&"
export * from "./StepNavi.vue?vue&type=script&lang=ts&"
import style0 from "./StepNavi.vue?vue&type=style&index=0&id=2f56437c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56437c",
  null
  
)

export default component.exports